<script>
  import { inertia } from '@inertiajs/svelte';
  import Icon from '@iconify/svelte';
  import AdminLayout from '../../components/AdminLayout.svelte';
  import Card from '../../components/ui/Card.svelte';
  import StatCard from '../../components/ui/StatCard.svelte';
  import StatusBadge from '../../components/StatusBadge.svelte';

  let {
    counts = {},
    recent_accounts = [],
  } = $props();

  const stats = [
    { key: 'accounts', label: 'Accounts', icon: 'mdi:account-multiple' },
    { key: 'admins', label: 'Admins', icon: 'mdi:shield-account' },
    { key: 'workspaces', label: 'Workspaces', icon: 'mdi:briefcase-outline' },
    { key: 'social_accounts', label: 'Connected accounts', icon: 'mdi:link-variant' },
    { key: 'posts', label: 'Posts', icon: 'mdi:pencil-outline' },
    { key: 'published_posts', label: 'Published', icon: 'mdi:check-circle-outline' },
  ];
</script>

<AdminLayout title="Overview">
  <div class="grid grid-cols-2 sm:grid-cols-3 gap-4 mb-8">
    {#each stats as s}
      <StatCard icon={s.icon} count={counts[s.key] ?? 0} label={s.label} />
    {/each}
  </div>

  <Card title="Newest accounts">
    {#if recent_accounts.length === 0}
      <p class="text-secondary-500 text-sm">No accounts yet.</p>
    {:else}
      <ul class="flex flex-col divide-y divide-secondary-100">
        {#each recent_accounts as acc}
          <li class="py-3 first:pt-0 last:pb-0">
            <a use:inertia href={`/admin/accounts/${acc.id}`} class="flex items-center justify-between gap-3 group">
              <span class="flex items-center gap-2 text-sm text-secondary-700 group-hover:text-primary-700">
                {acc.email}
                {#if acc.is_admin}
                  <Icon icon="mdi:shield-crown-outline" class="text-amber-500" title="Admin" />
                {/if}
              </span>
              <StatusBadge status={acc.status} />
            </a>
          </li>
        {/each}
      </ul>
    {/if}
  </Card>
</AdminLayout>
